import { LinkColorStyleSet } from './LinkBaseTypes';

export const disabledColor = '$color-secondary-a3';

export const variantStyleObject: LinkColorStyleSet = {
  default: {
    active: {
      color: '$color-primary-a2',
    },
    inactive: {
      color: '$color-primary-a3',
    },
  },
  inverse: {
    active: {
      color: '$color-primary-b2',
    },
    inactive: {
      color: '$color-primary-c1',
    },
  },
};